import { render, staticRenderFns } from "./SleQuickSuggestion.vue?vue&type=template&id=d70f83e2&scoped=true&"
import script from "./SleQuickSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SleQuickSuggestion.vue?vue&type=script&lang=ts&"
import style0 from "./SleQuickSuggestion.vue?vue&type=style&index=0&id=d70f83e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70f83e2",
  null
  
)

export default component.exports